import {Scilearn} from "../../constants";

export class TimerStatus {

    public static timeout = "Timeout Status";
    public static interval = "Interval Status";
    public static hard_exit = "Hard Exit Status";
    public static paused = "paused";
    public static started = "started";
    public static stopped = "stopped";

}

export class TimerTiming {
    public key: string;
    public stop: Array<string>;
    public pause: Array<string>;
    public prohibitInterrupt: Array<string>;

    constructor(options: any) {
        this.key = options.key;
        this.stop = options.stop || [];
        this.prohibitInterrupt = options.prohibitInterrupt || [];
    }

    public setPause(pause: Array<string>): void {
        this.pause = pause;
    }

    public setStop(stop: Array<string>): void {
        this.stop = stop;
    }

    public setProhibitInterrupt(prohibit: Array<string>): void {
        this.prohibitInterrupt = prohibit;
    }

}

export class TimerStrategy {
    public static studentSettingSet = new TimerTiming({ key: "studentSettingSet" });
    public static glossaryAudio = new TimerTiming({key: "glossaryAudio", prohibitInterrupt: [Scilearn._TRAINING_TIMER]});
    public static glossaryFact = new TimerTiming({key: "glossaryFact", prohibitInterrupt: [Scilearn._TRAINING_TIMER]});
    public static glossaryEndComplete = new TimerTiming({key: "glossaryEndComplete"});
    public static tutorial = new TimerTiming({key: "tutorial", stop: [Scilearn._INACTIVE_TIMER], prohibitInterrupt: [Scilearn._TRAINING_TIMER]});
    public static readRecord = new TimerTiming({key: "readRecord", stop: [Scilearn._INACTIVE_TIMER], prohibitInterrupt: [Scilearn._TRAINING_TIMER]});
    public static question = new TimerTiming({key: "question", prohibitInterrupt: [Scilearn._TRAINING_TIMER]});
}
